export const BASE_PATH = `/account`;
